import { Animation } from '@motionone/animation';
import { createAnimate } from './create-animate.es.js';
var animate = createAnimate(Animation);
export { animate };